import React from "react";
import Control from "../../../../common/Controls/Control";
import SaveBtn from "../../../../common/SaveBtn";
import useStatFilters from "./useStatFilters";
import StatContainer from "../StatContainer/StatContainer";

const commonInputProps = {
  margin: "m-0",
  noPaddingOnFormGroup: true,
  noBg: true,
  inputStyle: { borderRadius: 5 },
};

const StatFilters = ({ statActions }) => {
  const { statFilters, selectedShortcut, actions } = useStatFilters(
    statActions.refreshWithFilters
  );

  return (
    <StatContainer title="Filtres :">
      <div className="row w-100">
        <div className="col-12 col-md-6 d-flex flex-wrap mb-2 mb-md-0 justify-content-start">
          <button
            className={`btn btn-sm mr-2 my-1 border ${
              selectedShortcut == "1" ? "btn-primary" : "btn-default"
            }`}
            onClick={actions.updateFiltersLast30Days}
          >
            30 derniers jours
          </button>
          <button
            className={`btn btn-sm mr-2 my-1 border ${
              selectedShortcut == "2" ? "btn-primary" : "btn-default"
            }`}
            onClick={actions.updateFiltersLast3Months}
          >
            3 derniers mois
          </button>
          <button
            className={`btn btn-sm ml-0 my-1 border ${
              selectedShortcut == "3" ? "btn-primary" : "btn-default"
            }`}
            onClick={actions.updateFiltersForever}
          >
            Depuis toujours
          </button>
        </div>
        <div className="col-12 col-md-6 d-flex flex-wrap align-items-center justify-content-start">
          <Control
            className="mr-3"
            labelClassname="d-flex align-items-center mb-0 mb-md-2 mb-xl-0"
            innerLabelStyle={{ paddingRight: "5px" }}
            noMarginInsideLabel
            label="Du :"
            type="date"
            value={statFilters.beginAt}
            change={actions.handleChangeStatFilters}
            name="beginAt"
            {...commonInputProps}
          />
          <div className="d-flex flex-wrap">
          <Control
            labelClassname="d-flex align-items-center mb-0 mr-3"
            innerLabelStyle={{ paddingRight: "5px" }}
            noMarginInsideLabel
            label="Au :"
            type="date"
            value={statFilters.endAt}
            change={actions.handleChangeStatFilters}
            name="endAt"
            {...commonInputProps}
          />
          </div>
        </div>
      </div>
    </StatContainer>
  );
};

export default StatFilters;
